import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class AssetTypesService {
  static async getAll({ search, page, includeOnlyGeoActive = false }) {
    const params = {
      page,
      search,
      includeOnlyGeoActive
    };
    const { data } = await DataService.get(`${API.serviceAssetTypes.root}/`, params);

    return {
      assetTypes: data.assetTypes,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getById(id) {
    const { data } = await DataService.get(`${API.serviceAssetTypes.root}/${id}`);
    return {
      assetType: data.assetType,
    };
  }

  static async createAssetType(assetTypeData) {
    const { data: newData } = await DataService.post(API.serviceAssetTypes.root, assetTypeData);
    return {
      assetType: newData.assetType,
    };
  }

  static async updateAssetType(id, newData) {
    const { data } = await DataService.patch(`${API.serviceAssetTypes.root}/${id}/`, newData);
    return {
      asset: data,
    };
  }

  static async getAssetTypeById(id) {
    const { data } = await DataService.get(`${API.serviceAssetTypes.root}/${id}`);
    return {
      assetType: data.assetType,
    };
  }

}

export { AssetTypesService };
